import { UserDetailComponent } from './../../user-detail/user-detail.component';
import { Component, ViewChild } from '@angular/core';
import { User } from '../../model/user';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { UserService } from 'src/app/core/service/user.service';
import { DeactivationGuarded } from 'src/app/core/routing/can-deactivate-guard.service';
import { AppComponent } from 'src/app/app.component';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss']
})
export class UserAccountComponent implements DeactivationGuarded
{
  @ViewChild('userDetail') public userDetail: UserDetailComponent;

  /**
   * Current selected user.
   */
  public selectedUser: User = null;

  /**
   * Indicates if the account page is launched from the Account (isAdmin=false) or Users page (isAdmin=true).
   */
  public isAdmin = false;

  constructor(private authService: AuthenticationService,
    private userService: UserService,
    private messageHandlerService: MessageHandlerService,
    private appComponent: AppComponent)
  {
    this.loadUser();
  }

  /**
   * Cancel Account changes.
   */
  public cancel(): void
  {
    this.authService.navigateToDefaultPage();
  }

  /**
   * canDesactivate event implementation for monitoring if dirty changes and navigation without saving
   */
  public canDeactivate(): boolean | Observable<boolean> | Promise<boolean>
  {
    if (this.userDetail?.formDirty())
    {
      this.appComponent.openUnsavedDialog();
      return this.appComponent.navigateAwaySelection;
    }

    return true;
  }

  /**
   * Load current logged in user.
   */
  private loadUser()
  {
    this.selectedUser = null;
    const user = this.authService.currentUser;
    this.userService.getUserById(user.id, true).subscribe({
      next: (data) =>
      {
        this.selectedUser = data;
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }
}
